// NE SPREMINJAJ!!!
export const ssoConfigGlobal = {
  AUTH0_USE_ACCESS_TOKEN: true,
  AUTH0_CLIENT_ID: 'servisne',
  AUTH0_DOMAIN: 'test-login.t-2.net/',
  AUTH0_CALLBACK_URL: location.href,
  AUTH0_RESPONSE_TYPE: 'token',
  ACCESS_TOKEN_NAME: 'access_token',
  ACCESS_TOKEN_EXPIRES_AT: 'access_token_expires_at'
}
// NE SPREMINJAJ!!!



//////////////////
// WEBPACK FOOTER
// ./config/sso_conf_global.js
// module id = 9EYA
// module chunks = 3